module.exports = __webpack_public_path__ + "img/Rhonda_Morris@3x.b264a897.png";